package fr.manyverse.app.presentation.components.soundboard

import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.SoundTag
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.tag_calm
import manyverse.shared.generated.resources.tag_combat
import manyverse.shared.generated.resources.tag_tension
import org.jetbrains.compose.resources.stringResource

/**
 * Colored tag filter chips for sound mood filtering.
 */
@Composable
fun SoundFilterChips(
    selectedTags: Set<SoundTag>,
    onTagToggle: (SoundTag) -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SoundTag.entries.forEach { tag ->
            val isSelected = tag in selectedTags
            val palette = soundTagPalette(tag)

            FilterChip(
                selected = isSelected,
                onClick = { onTagToggle(tag) },
                label = {
                    Text(
                        text = when (tag) {
                            SoundTag.CALM -> stringResource(Res.string.tag_calm)
                            SoundTag.COMBAT -> stringResource(Res.string.tag_combat)
                            SoundTag.TENSION -> stringResource(Res.string.tag_tension)
                        }
                    )
                },
                colors = FilterChipDefaults.filterChipColors(
                    selectedContainerColor = palette.container,
                    selectedLabelColor = palette.label,
                    labelColor = palette.label.copy(alpha = 0.6f)
                )
            )
        }
    }
}
